/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.updates.survey.rpc.MeetingLinkRpc
 */

export const getMeetingLinkRpc = {
  serviceName: 'com.hubspot.product.updates.survey.rpc.MeetingLinkRpc',
  rpcName: 'getMeetingLink',
  auth: 'app',
  fingerprint: '8hrG47FN6tKRvEwTX3OKN1CcY11a3iid',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};